import React from "react";

export const FirstLoginContext = React.createContext({
  firstLogin: false,
  setFirstLogin: (firstLogin: boolean) => {}
});
